import { createUser, deleteUserById, readUserById, readUsers, replaceUser } from 'api/user';
import { readUserRoleById } from 'api/userRole';
import { UserFormData, GooglePlaceAddress, UserResponseViewModel } from 'types/user';
import { parseJwt } from 'utils/parseJwt';
import { getTransformedGoogleAddressFromResponse, getTransformedGoogleAddressToRequest } from './utils';
import { GetUsersRequest } from 'api/user/types';
import { isNull } from 'lodash';
import { DEFAULT_USER_PROFILE_IMAGE } from 'pages/constants/user';
import { getRoleById } from 'services/roleServices';

export const getUserBasicData = async (token: string) => {
    const tokenPayload = parseJwt(token);
    const userId = tokenPayload.sub as string;
    const userInfo = await readUserById({ id: userId });
    const role = await getRoleById(userInfo.data.roleId);

    return { userInfo: userInfo.data, role: role };
};

export const getUserById = (id: string) => readUserById({ id }).then(({ data }) => data);

export const getUserProfile = (id: string) =>
    readUserById({ id }).then((res) => {
        const { id, profilePicture, firstName, lastName, phoneNumber, password, email } = res.data;
        return {
            id,
            email,
            profilePicture: isNull(profilePicture)
                ? DEFAULT_USER_PROFILE_IMAGE
                : { image: profilePicture.filePath, fileName: profilePicture.fileName },
            firstName,
            lastName,
            address: getTransformedGoogleAddressFromResponse(res.data.address, res.data.placeId),
            phoneNumber,
            password,
            confirmationPassword: password,
        };
    });

export const updateUserProfile = ({ address, ...data }: UserFormData, id: string) => {
    const requestData = {
        ...data,
        ...getTransformedGoogleAddressToRequest(address),
    };
    return replaceUser(requestData, id).then((res) => res.data);
};

export const createNewUser = ({ address, ...data }: UserFormData) => {
    const requestData = {
        ...data,
        ...getTransformedGoogleAddressToRequest(address),
    };
    return createUser(requestData).then((res) => res.data);
};

export const updateUser = ({ address, ...data }: UserFormData, id: string) => {
    const requestData = {
        ...data,
        ...getTransformedGoogleAddressToRequest(address),
    };
    return replaceUser(requestData, id).then((res) => res.data);
};

export const getUsers = (params: GetUsersRequest) => {
    return readUsers(params).then((res) => res.data);
};

export const deleteUser = (id: string) => deleteUserById({ id }).then((res) => res.data);
